import { gql } from "@apollo/client";

import { GOAL_FRAGMENT } from "./goal";

export const USER_FRAGMENT = gql`
  fragment UserFragment on User {
    id
    partner
    partnerId
    partnerType
    provider
    email
    firstName
    preferredName
    lastName
    phoneNumber
    phoneNumberVerified
    dateOfBirth
    language
    residenceStatus
    countryOfCitizenship
    status
    termsAccepted
    maritalStatus
    userAddress {
      id
      unitNo
      street
      city
      state
      country
      postalCode
    }
    userFinancialProfile {
      id
      investmentPriority
      investmentHorizon
      downturnReaction
      employmentStatus
      employerName
      employerAddressUnitNo
      employerAddressStreet
      employerAddressCity
      employerAddressState
      employerAddressCountry
      employerAddressPostalCode
      occupationTitle
      occupationIndustry
      isFinraAffiliated
      isPoliticallyExposed
      isFamilyPoliticallyExposed
      sourceOfFunds
      liquidNetWorth
      annualIncome
      trustedContactFirstName
      trustedContactLastName
      trustedContactEmail
      trustedContactPhoneNumber
    }
    userTaxProfiles {
      id
      taxId
      taxIdType
      countryOfTaxResidence
      stateOfTaxResidence
    }
    settings {
      referralsEnabled
      capitalGroupMigrationEnabled
      capitalGroupMigrationInProgress
      capitalGroupMigrationOverride
      plaidRelinkBannerEnabled
      achContributionFailedBankReLinkPopUp
      achContributionNotProcessedBankReLinkPopUp
      achConnectYourBankReLinkPopUp
      achUnauthorizedPopUp
    }
  }
`;

export const BENEFICIARIES_FRAGMENT = gql`
  ${GOAL_FRAGMENT}
  fragment BeneficiariesFragment on Beneficiary {
    id
    type
    firstName
    lastName
    dateOfBirth
    taxIdProvided
    goals {
      ...GoalFragment
    }
  }
`;
